import React, { useEffect,useState,useRef} from 'react';

import {
    Button,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Select,
    Textarea,
    InputGroup,
    InputRightElement,
    Tooltip,
    IconButton,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Text,
    Box,

} from '@chakra-ui/react'
import { VscAdd } from 'react-icons/vsc';
import { useDispatch ,useSelector} from 'react-redux';
import { getClienteByDni,getSiguienteNroPresupuesto } from '../../features/clienteSlice';
import { getPresupuestos } from '../../features/presupuestoSlice';
import { createPresupuesto } from '../../features/presupuestoSlice';
import { Icon } from "@chakra-ui/react";
import { Search2Icon } from '@chakra-ui/icons';
import { MdDelete,MdAssignmentAdd} from 'react-icons/md';
import { VscEdit } from 'react-icons/vsc';
import { ModalAgregarClienteFactura } from '../cliente/ModalAgregarClienteFactura';
import { ToastChakra } from '../../helpers/toast';
import { ModalBuscarCliente } from '../factura/ModalBuscarCliente';

export const ModalAgregarPresupuesto = ({ page, perPage }) => {
    const dispatch = useDispatch();
    const [isModalClienteOpen, setIsModalClienteOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const errorGetClienteByDni = useSelector((state) => state.clientes.errorGetClienteByDni);
    const isError = useSelector((state) => state.clientes.isError);
    const [isBuscarModalOpen, setIsBuscarModalOpen] = useState(false);


    const handleModalClienteClose = () => setIsModalClienteOpen(false);

    const descripcionRef = useRef(null); // Referencia para el campo de Descripción

    const [servicios, setServicios] = useState([]);
  
    const [editIndex, setEditIndex] = useState(null); // Índice del registro en edición

    useEffect(() => {
        if (isError && errorGetClienteByDni) {
            ToastChakra('ERROR', errorGetClienteByDni, 'error', 3000, 'bottom-right');
        }
    }, [isError, errorGetClienteByDni]);

    // Formatear el precio a moneda con separadores de miles
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true, // 🔹 Esto activa los puntos de miles
        }).format(value);
    };

    const initialValues = {
        nroPresupuesto: '',
        fechaPresupuesto : new Date().toISOString().split('T')[0], // Fecha actual en formato YYYY-MM-DD
        clienteId : '',
        cliente: '',
        direccion: '',
        dni: '',
        descripcion: '',
        estado: 'AC',
        condicionPago:'CO',
        iva: 21,
        precioUnitario: '0',
        cantidad: '1',
        observaciones: 'Forma de pago 50% al empezar y el resto al acabar',
        descripcion_reforma: ''

    };
    const [indice, setIndice] = useState(initialValues);

    const handleBuscarSiguienteNro = (dispatch, setIndice) => {
        dispatch(getSiguienteNroPresupuesto(null))
            .then((response) => {
                const siguienteNumero = response.payload; // Ajusta esto según la estructura de la respuesta
                if (siguienteNumero) {
                    setIndice((prev) => ({
                        ...prev,
                        nroPresupuesto: siguienteNumero.siguienteNumero, // Actualiza el número de factura
                    }));
                } else {
                    ToastChakra('ERROR', 'No se pudo obtener el siguiente número de factura', 'error', 3000, 'bottom-right');
                }
            })
            .catch((error) => {
                console.error('Error al obtener el siguiente número de factura:', error);
                alert('Error al obtener el siguiente número de factura. Por favor, intente nuevamente.');
            });
    };

    const handleBuscarCliente = () => {
        if (!indice.dni) {
            setIsBuscarModalOpen(true); // Abrimos el modal
            return;  
        }
    
        // Llama a la acción para buscar el cliente por DNI
        dispatch(getClienteByDni(indice.dni))
            .then((response) => {
                const cliente = response.payload; // Ajusta esto según la estructura de la respuesta
                if (cliente && cliente.success) { // Verifica si la respuesta tiene éxito
                    setIndice((prev) => ({
                        ...prev,
                        cliente: cliente.nombre, // Actualiza el nombre del cliente
                        direccion: cliente.direccion, // Actualiza la dirección del cliente
                        clienteId: cliente.id, // Guarda el ID del cliente si es necesario
                    }));
                } else {
                   // alert('Cliente no encontrado.');
                    setIndice((prev) => ({
                        ...prev,
                        cliente: '',
                        direccion: '',
                        clienteId: '',
                    }));
                }
            })
            .catch((error) => {
                console.error('Error al buscar el cliente:', error);
                //alert('Error al buscar el cliente. Por favor, intente nuevamente.');
            });
    };

    const handleModalOpen = () => {
        setIsModalOpen(true); // Abre el modal inmediatamente
    };

    useEffect(() => {
        if (isModalOpen) {
            setServicios([]); // limpia tabla
         //   setIndice({ descripcion: '', cantidad: '1', precioUnitario: '0', iva: '', dni: '', cliente : ''}); // limpia campos
                handleBuscarSiguienteNro(dispatch, setIndice); // Llama automáticamente a la función al abrir el modal
        }
    }, [isModalOpen, dispatch]);
    
    const handleModalClose = () => {
        setIsModalOpen(false);
        setIndice(initialValues);
    };

    const handleSave = () => {

        // Recupera el usuario desde el localStorage
        const user = JSON.parse(localStorage.getItem('user')); // Parsea el JSON almacenado
        const usuarioId = user?.usuario?.id; // Obtén el id del usuario

        const datos = {
            nroPresupuesto: indice.nroPresupuesto,
            fechaPresupuesto: indice.fechaPresupuesto,
            clienteId: indice.clienteId,
            totalGeneral: totalGeneral.toFixed(2), // Calculado dinamicamente
            observaciones : indice.observaciones,
            descripcion_reforma : indice.descripcion_reforma,
            usuarioId : usuarioId,
            estado : indice.estado,
            condicionPago : indice.condicionPago,
            detalles : servicios.map((servicio) => ({
                descripcion: servicio.descripcion,
                cantidad: servicio.cantidad,
                precioUnitario: servicio.precioUnitario,
                iva: servicio.iva,
                precioTotal: servicio.precioTotal,
            })),
        }
        dispatch(createPresupuesto(datos)).then(() =>{
            dispatch(getPresupuestos({ page, perPage })); // Usa los valores pasados como props y Actualiza 
            setIsModalOpen(false)
            setIndice(initialValues)
        });
       
    }


    const handleAgregarServicio = () => {
        if (!indice.descripcion || !indice.cantidad || !indice.precioUnitario || !indice.iva) {
            ToastChakra('ERROR', 'Por favor, complete todos los campos del servicio.', 'error', 3000, 'bottom-right');
            //alert("Por favor, complete todos los campos del servicio.");
            return;
        }

          // 🚫 Validación de límite máximo de 17 registros
        if (editIndex === null && servicios.length >= 17) {
            ToastChakra('Límite alcanzado', 'No se pueden agregar más de 17 registros.', 'warning', 3000, 'bottom-right');
            return;
        }
    
        const precioTotal = indice.cantidad * indice.precioUnitario * (1 + indice.iva / 100);
    
        if (editIndex !== null) {
            // Actualiza el registro existente
            const nuevosServicios = [...servicios];
            nuevosServicios[editIndex] = {
                descripcion: indice.descripcion,
                cantidad: indice.cantidad,
                iva: indice.iva,
                precioUnitario: indice.precioUnitario,
                precioTotal: precioTotal.toFixed(2),
            };
            setServicios(nuevosServicios);
            setEditIndex(null); // Restablece el índice de edición
        } else {
            // Agrega un nuevo registro
            setServicios([
                {
                    descripcion: indice.descripcion,
                    cantidad: indice.cantidad,
                    iva: indice.iva,
                    precioUnitario: indice.precioUnitario,
                    precioTotal: precioTotal.toFixed(2),
                },
                ...servicios, // los anteriores se agregan después
            ]);
        }
    
        // Limpia los campos relacionados con el servicio
        setIndice({ ...indice, descripcion: '', cantidad: '1', precioUnitario: '0' });
    
        // Enfoca el campo de Descripción
        setTimeout(() => {
            descripcionRef.current?.focus();
        }, 0); // Usa un timeout para garantizar que el DOM esté actualizado
    };



    const handleEditarServicio = (index) => {
        const servicioSeleccionado = servicios[index]; // Obtén el servicio seleccionado
        setIndice({
            ...indice,
            descripcion: servicioSeleccionado.descripcion,
            cantidad: servicioSeleccionado.cantidad,
            precioUnitario: servicioSeleccionado.precioUnitario,
            iva: servicioSeleccionado.iva,
        });
        setEditIndex(index); // Establece el índice del registro en edición
    
        // Enfoca el campo de Descripción
        setTimeout(() => {
            descripcionRef.current?.focus();
        }, 0); // Usa un timeout para garantizar que el DOM esté actualizado
    };

    const handleEliminarServicio = (index) => {
        const nuevosServicios = servicios.filter((_, i) => i !== index); // Filtra el servicio a eliminar
        setServicios(nuevosServicios); // Actualiza el estado con los servicios restantes
    };

     // Esta función se llamará desde el modal al hacer clic en un cliente
     const handleSeleccionarCliente = (cliente) => {
        setIndice({
            ...indice,
            dni: cliente.dni,
            cliente: cliente.nombre + ' ' + cliente.apellido,
            clienteId: cliente.id,
            direccion: cliente.direccion || '', // Asegúrate de que la dirección esté definida

        });

        setIsBuscarModalOpen(false); // Cerramos el modal
    };

    // Calcular los totales
    const totalBase = servicios.reduce((acc, servicio) => acc + servicio.cantidad * servicio.precioUnitario, 0);
    const totalIVA = servicios.reduce((acc, servicio) => acc + (servicio.cantidad * servicio.precioUnitario * servicio.iva) / 100, 0);
    const totalGeneral = totalBase + totalIVA;

    return (
        <>
            <Button
                colorScheme="blue"
                _dark={{ bg: "blue.500", color: "white", _hover: { bg: "blue.600" }}}
                aria-label="Agregar"
                leftIcon={<Icon as={VscAdd} fontSize="lg" />}
                variant="solid"
                rounded={'xl'}
                onClick={handleModalOpen}
            >
                Registrar
            </Button>
            <Modal isOpen={isModalOpen} onClose={handleModalClose} isCentered>
                <ModalOverlay 
                    bg="rgba(11,15,25, 0.8)"
                    backdropFilter='auto'
                    backdropBlur='2px'
                />
                <ModalContent _dark={{ bg: "primary.1000" }} borderRadius="2xl" maxWidth="90%">
                    <ModalHeader textAlign="center">AGREGAR NUEVO PRESUPUESTO</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                         {/* Contenedor principal */}
                        <Stack spacing={2} direction="column" p={4}> {/* Reduce el spacing entre los Stack */}
                            {/* Primer Stack */}
                            <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                <FormControl isRequired>
                                    <FormLabel fontWeight="semibold" fontSize="xs">NRO. PRESUPUESTO</FormLabel>
                                    <InputGroup size="sm">
                                        <Input
                                            placeholder="Número de factura"
                                            type="text"
                                            size="sm"
                                            value={indice.nroPresupuesto} // Muestra el número de factura
                                            isReadOnly // Hace que el campo sea de solo lectura
                                        />
                                         <InputRightElement width="2.5rem" display="none">
                                            <Tooltip hasArrow label="Buscar sgte nro. de factura" placement="auto">
                                                <IconButton
                                                    aria-label="Buscar"
                                                    rounded="full"
                                                    size="xs"
                                                    icon={<Icon as={Search2Icon} fontSize="md" />}
                                                    colorScheme="green"
                                                    variant="solid"
                                                    onClick={handleBuscarSiguienteNro} // Llama a la función para reusar el siguiente número
                                                />
                                            </Tooltip>
                                        </InputRightElement>
                                    </InputGroup>
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel fontWeight={'semibold'} fontSize="xs">FECHA DE EMISIÓN</FormLabel>
                                    <Input
                                        type="date"
                                        size="sm"
                                        value={indice.fechaPresupuesto} // Formato YYYY-MM-DD
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setIndice({ ...indice, fechaPresupuesto: value ? value : null });
                                        }}
                                    />
                                </FormControl> 
                                <FormControl isRequired>
                                    <FormLabel fontWeight={'semibold'}fontSize="xs">CONDICION DE PAGO</FormLabel>
                                    <Select
                                
                                        size="sm"
                                        onChange={(e) => setIndice({ ...indice, condicionPago: e.target.value })}
                                        value={indice.condicionPago} // Muestra la condición de pago seleccionada
                                    >
                                        <option value="CO">CONTADO</option>
                                        <option value="CRE">CRÉDITO</option>
                                    </Select>
                                </FormControl>   

                                <FormControl isRequired>
                                    <FormLabel fontWeight={'semibold'}fontSize="xs">ESTADO</FormLabel>
                                    <Select
                                        size="sm"
                                        onChange={(e) => setIndice({ ...indice, estado: e.target.value })}
                                        value= {indice.estado} // Sincroniza con el estado  
                                    >
                                        <option value="AC">ACTIVO</option>
                                        <option value="PE">PENDIENTE</option>
                                    </Select>
                                </FormControl> 
                                
                            </Stack>

                            {/* Segundo Stack */}
                            <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                <FormControl isRequired flex="1">
                                    <FormLabel fontWeight="semibold" fontSize="xs">DNI/RUC</FormLabel>
                                    <InputGroup size="sm">
                                        <Input
                                            type="text"
                                            placeholder="Ingrese dni/ruc"
                                            size="sm"
                                            value={indice.dni}
                                            onChange={(e) => {
                                                const valorFormateado = e.target.value.toUpperCase().replace(/[^A-Z0-9-]/g, ''); // Formatea el valor a mayúsculas y elimina caracteres no alfanuméricos
                                                setIndice({ ...indice, dni: valorFormateado });
                                            }}
                                        />
                                        <InputRightElement width="2.5rem">
                                            <Tooltip hasArrow label="Buscar por dni/ruc" placement="auto">
                                                <IconButton
                                                    aria-label="Buscar"
                                                    rounded="full"
                                                    size="xs"
                                                    icon={<Icon as={Search2Icon} fontSize="md" />}
                                                    colorScheme="green"
                                                    variant="solid"
                                                    onClick={handleBuscarCliente} // Llama a la función para buscar el cliente
                                                />
                                            </Tooltip>
                                        </InputRightElement>
                                    </InputGroup>
                                </FormControl>

                                <FormControl flex="2">
                                    <FormLabel fontWeight="semibold" fontSize="xs">CLIENTE</FormLabel>
                                    <Input
                                        type="text"
                                        placeholder="Nombre del cliente"
                                        size="sm"
                                        value={indice.cliente} // Muestra el nombre del cliente
                                        isReadOnly // Hace que el campo sea de solo lectura
                                    />
                                </FormControl>
                                <FormControl flex="2">
                                    <FormLabel fontWeight="semibold" fontSize="xs">DIRECCION</FormLabel>
                                    <Input
                                        type="text"
                                        placeholder="Dirección del cliente"
                                        size="sm"
                                        value={indice.direccion} // Muestra la direccion del cliente
                                        isReadOnly // Hace que el campo sea de solo lectura
                                    />
                                </FormControl>
                                {/* Modal para agregar cliente */}
                                <ModalAgregarClienteFactura
                                    isOpen={isModalClienteOpen}
                                    onClose={handleModalClienteClose}
                                />

                               
                            </Stack>

                            {/* Tercer Stack */}
                            <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                <FormControl>
                                    <FormLabel fontWeight="semibold" fontSize="xs">DESCRIPCION DEL SERVICIO</FormLabel>
                                    <Textarea
                                        ref={descripcionRef} // Asigna la referencia
                                        placeholder="Escribe la descripcion del servicio"
                                        type="text"
                                        size="sm"
                                        rows={1} // Cambia la cantidad de líneas visibles
                                        value={indice.descripcion} // Sincroniza con el estado
                                        onChange={(e) => setIndice({ ...indice, descripcion: e.target.value })}
                                        maxLength={150} // Limita a 100 caracteres
                                    />
                                     <Text fontSize="xs" color="gray.500" mt={1}>
                                        {indice.descripcion.length}/150 caracteres
                                     </Text>
                                </FormControl>
                            </Stack>

                            {/* Cuarto Stack */}
                            <Stack spacing={4} direction={{ base: "column", lg: "row" }} justifyContent="space-between">
                                <FormControl isRequired>
                                    <FormLabel fontWeight="semibold" fontSize="xs">CANTIDAD</FormLabel>
                                    <Input
                                        type="number"
                                        placeholder="Ingrese la cantidad"
                                        size="sm"
                                        value={indice.cantidad} // Sincroniza con el estado
                                        onChange={(e) => setIndice({ ...indice, cantidad: e.target.value })}
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel fontWeight="semibold" fontSize="xs">PRECIO UNITARIO</FormLabel>
                                    <Input
                                        type="number"
                                        size="sm"
                                        placeholder="Ingrese el Precio Unitario"
                                        value={indice.precioUnitario} // Sincroniza con el estado
                                        onFocus={(e) => {
                                            if (indice.precioUnitario === '0') {
                                              setIndice({ ...indice, precioUnitario: '' });
                                            }
                                          }}
                                        onChange={(e) => setIndice({ ...indice, precioUnitario: e.target.value })}
                                    />
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel fontWeight="semibold" fontSize="xs">IVA</FormLabel>
                                    <Select
                                        size="sm"
                                        onChange={(e) => setIndice({ ...indice, iva: e.target.value })}
                                    >
                                        <option value="21">21 %</option>
                                        <option value="10">10 %</option>
                                        <option value="0">Ninguno</option>
                                    </Select>
                                </FormControl>

                                {/* Botón Agregar*/}
                                <FormControl>
                                    <Tooltip hasArrow label='Agregar en la tabla' placement='auto'>
                                        <IconButton
                                            colorScheme="purple"
                                            _dark={{ bg: "purple.600", color: "white", _hover: { bg: "purple.700" } }}
                                            aria-label="Agregar"
                                            icon={<Icon as={MdAssignmentAdd} fontSize="2xl" />}
                                            variant="solid"
                                            borderRadius={'xl'}
                                            onClick={handleAgregarServicio} // Llama a la función para agregar el servicio
                                            disabled={!indice.descripcion || !indice.cantidad || !indice.precioUnitario } // Deshabilita si los campos están vacíos
                                            alignSelf="center" // Centra el botón verticalmente
                                            mt={5} // Agrega margen superior para bajar el botón
                                        />
                                    </Tooltip>
                                </FormControl>
                            </Stack>
                            {/* Contenedor de la tabla: Clave para el responsive */}
                            <Box borderWidth="1px" p={3} borderRadius="md">          
                                <Box
                                    maxH={servicios.length > 2 ? "200px" : "auto"}
                                    overflowY={servicios.length > 2 ? "auto" : "visible"}
                                     // APLICA ESTO PARA EL SCROLL HORIZONTAL EN MÓVILES
                                    overflowX={{ base: "auto", lg: "visible" }} // Desplazamiento horizontal solo en pantallas pequeñas
                                    whiteSpace="nowrap" // Evita que el contenido de la tabla se rompa en varias líneas
                                >
                                    <Table variant="simple" size="sm" mt={2}>
                                        <Thead>
                                            <Tr>
                                            <Th fontSize="xs">Descripción</Th>
                                            <Th fontSize="xs">Cantidad</Th>
                                            <Th fontSize="xs">Precio Unitario</Th>
                                            <Th fontSize="xs">IVA %</Th>
                                            <Th fontSize="xs">Total</Th>
                                            <Th fontSize="xs">Acciones</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {servicios.map((servicio, index) => (
                                                <Tr key={index}>
                                                    <Td fontSize="xs">{servicio.descripcion}</Td>
                                                    <Td fontSize="xs">{servicio.cantidad}</Td>
                                                    <Td fontSize="xs">{formatCurrency(servicio.precioUnitario)}</Td> {/* Formatear Precio Unitario */}
                                                    <Td fontSize="xs">{servicio.iva}%</Td>
                                                    <Td fontSize="xs">{formatCurrency(servicio.precioTotal)}</Td> {/* Formatear Precio Total */}
                                                    <Td fontSize="xs">
                                                        {/* Botón de edición */}
                                                        <Tooltip hasArrow label='Editar' placement='auto'>
                                                            <IconButton
                                                                colorScheme="blackAlpha"
                                                                _dark={{ color: "white", _hover: { bg: "whiteAlpha.200" } }}
                                                                aria-label="Editar"
                                                                icon={<Icon as={VscEdit}
                                                                    fontSize="lg" />}
                                                                variant="ghost"
                                                                onClick={() => handleEditarServicio(index)} // Llama a la función de edición
                                                                ml={2}
                                                            />
                                                        </Tooltip>

                                                        {/* Botón de eliminación */}
                                                        <Tooltip hasArrow label='Eliminar' placement='auto'>
                                                            <IconButton
                                                                aria-label="Eliminar"
                                                                onClick={() => handleEliminarServicio(index)} // Llama a la función de eliminación
                                                                icon={<Icon as={MdDelete} />}
                                                                fontSize="lg"
                                                                colorScheme="red"
                                                                variant={'ghost'}
                                                                _dark={{ color: "white", _hover: { bg: "red.800" } }}
                                                                ml={2}
                                                            />
                                                        </Tooltip>
                                                    </Td>
                                                </Tr>
                                            ))}
                                        </Tbody>
                                    </Table>
                                </Box> 
                            </Box>  

                            {/* 👇 Contador debajo de la tabla */}
                            <Text fontSize="sm" mt={2} textAlign="right" color="gray.600" _dark={{ color: "gray.300" }}>
                                Mostrando {servicios.length} {servicios.length === 1 ? 'registro' : 'registros'} 
                            </Text>  
                            {/* Totales */}
                            <Box mt={4} p={4} borderWidth="1px" borderRadius="lg" bg="gray.50" _dark={{ bg: "gray.800" }}>
                                <Stack direction={{ base: "column", md: "row" }}>
                                    {/* Columna izquierda: Observaciones */}
                                    <FormControl flex="1">
                                        <FormLabel fontWeight="semibold" fontSize="sm">Observaciones</FormLabel>
                                        <Textarea
                                            placeholder="Escribe alguna observación si es necesario"
                                            size="sm"
                                            rows={2} // Cambia la cantidad de líneas visibles
                                            value={indice.observaciones} // Sincroniza con el estado
                                            onChange={(e) => setIndice({ ...indice, observaciones: e.target.value })}
                                            maxLength={100} // Limita a 100 caracteres
                                       />
                                        <Text fontSize="xs" color="gray.500" mt={1}>
                                            {indice.observaciones.length}/100 caracteres
                                        </Text>
                                    </FormControl>
                                    <FormControl flex="1">
                                        <FormLabel fontWeight="semibold" fontSize="sm">Descripcion de la reforma y puesupuesto</FormLabel>
                                        <Textarea
                                            placeholder="Escribe alguna descripción si es necesario"
                                            size="sm"
                                            rows={2} // Cambia la cantidad de líneas visibles
                                            value={indice.descripcion_reforma || ''} // Sincroniza con el estado
                                            onChange={(e) => setIndice({ ...indice, descripcion_reforma: e.target.value })}
                                            maxLength={100} // Limita a 100 caracteres
                                       />
                                        <Text fontSize="xs" color="gray.500" mt={1}>
                                            {indice.descripcion_reforma.length}/100 caracteres
                                        </Text>
                                    </FormControl>

                                    {/* Columna derecha: Resultados */}
                                    <Stack spacing={2} flex="1" alignItems={{ base: "flex-start", md: "flex-end" }}> {/* Alinea los resultados al borde derecho */}
                                        <Text fontSize="sm" fontWeight="bold">
                                            Total Base (sin IVA): <Text as="span" color="green.500">{formatCurrency(totalBase)}</Text>
                                        </Text>
                                        <Text fontSize="sm" fontWeight="bold">
                                            Total IVA: <Text as="span" color="green.500">{formatCurrency(totalIVA)}</Text>
                                        </Text>
                                        <Text fontSize="sm" fontWeight="bold">
                                            Total General: <Text as="span" color="green.500">{formatCurrency(totalGeneral)}</Text>
                                        </Text>
                                    </Stack>
                                </Stack>
                            </Box>
                        </Stack>
                    </ModalBody>
                    <ModalFooter mt={-2}> {/* Reduce el margen superior */}
                        <Button
                            colorScheme="red"
                            _dark={{ bg: "red.500", color: "white", _hover: { bg: "red.600" } }}
                            size="sm"
                            mr={3}
                            onClick={handleModalClose}
                            borderRadius="xl"
                        >
                            CANCELAR
                        </Button>
                        <Button
                            colorScheme="blue"
                            _dark={{ bg: "blue.500", color: "white", _hover: { bg: "blue.600" } }}
                            size="sm"
                            mr={3}
                            onClick={handleSave}
                            borderRadius="xl"
                            disabled={!indice.dni || !indice.cliente || servicios.length === 0 || !indice.nroPresupuesto || !indice.fechaPresupuesto || !indice.condicionPago || !indice.estado} // Deshabilita si los campos obligatorios están vacíos
            
                        >
                            GUARDAR
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            {/* 👉 Aquí se integra el ModalBuscarPersona */}
            <ModalBuscarCliente
                isOpen={isBuscarModalOpen}
                onClose={() => setIsBuscarModalOpen(false)}
                onSelectCliente={handleSeleccionarCliente}
            />
        </>
    )
}
